module.exports = __webpack_public_path__ + "static/img/SRZ.a0e972b1.jpg";